import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
  required,
  requiredIf,
  maxLength,
  minLength,
  numeric,
  not,
  sameAs
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import store from '../../store';
import {
  mapGetters
} from "vuex";
import CONFIG from "@/assets/js/config.js";
import ImportForm from "@/components/image_import/ImportForm.vue";


export default {
  name: "StudentCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading,
    ImportForm,
  },

  data() {
    return {
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      config: {
        maxDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + (new Date().getDate() - 1)
      },
      studentData: {},
      gradeFeeData: {},
      parentData: {},
      student_image: '',
      // c_student_no: '',
      campus_id: '',
      entry_no: '',
      gradeArr: [],
      grade: '',
      religion: '',
      section: '',
      religionArr: null,
      sectionArr: [{
        id: 0,
        text: 'Choose Section'
      }],
      selectedSection: 0,
      selectedGrade: 0,
      selectedReligion: 0,
      submitted: false,
      isLoading: false,
      disabled: false,
      existingParent: false,
      noSectionMsg: '',

      url: '/class/create?rd_back=student',
      section_exist: '',

      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoadingWebcam: false,
      link: '#',
      academic_year:'',
      scanFileType: 'student',
    };
  },

  validations: {
    student_image: {},
    grade: {
      required
    },
    religion: {
      required
    },
    entry_no: {
      maxLength: maxLength(20)
    },
    section: {
      required
    },
    studentData: {
      name: {
        required,
        maxLength: maxLength(100)
      },
      dob: {
        required,
        maxLength: maxLength(100)
      },
      gender: {
        required
      },
      nationality: {
        maxLength: maxLength(100)
      },
      weight: {
        maxLength: maxLength(20)
      },
      height: {
        maxLength: maxLength(20)
      },
      sibling: {
        numeric,
        maxLength: maxLength(2)
      },
      phone1: {
        required: requiredIf(() => store.state.setting.clientType != 'school'),
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11),
      },
      phone2: {
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11),
        notSameAs: not(sameAs('phone1'))
      },
      hobby: {
        maxLength: maxLength(1000)
      },
      allergic_food: {
        maxLength: maxLength(1000)
      },
      special_topic: {
        maxLength: maxLength(1000)
      },
      blood: {
        maxLength: maxLength(20)
      },
      previous_school: {
        maxLength: maxLength(200)
      }
    },
  },

  computed: {
    ...mapGetters(['getUser']),
  },

  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoadingWebcam = true;

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const constraints = (window.constraints = {
          audio: false,
          video: true
        });

        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.isLoadingWebcam = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            console.log(error);
            this.isLoadingWebcam = false;
            alert("May the browser didn't support or there is some errors.");
          });
      } else {
        this.isLoadingWebcam = false;
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        alert("Sorry, your browser or device does not support accessing the camera. Please try using a different browser or device.");
      }
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
      this.student_image = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      this.isCameraOpen = false;
      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.stopCameraStream();
    },

    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },

    getGradeFee(gradeId, request) {
      axios.get("getGradeFee/" + gradeId, request)
        .then(res => {
          this.gradeFeeData = res.data[0] ?? {'annual_fee': '', 'monthly_fee': ''};
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getReligion() {
      const result = [{
        id : 0,
        text: 'Select'
      }];
      Object.entries(CONFIG.RELIGION).forEach(([id, key]) => {
        result.push({
          id: id,
          text: key
        });
      });
      this.religionArr = result;
    },
    
    getParentDetail() {
      axios.get("/parent/detail/" + this.$route.params.parentId)
        .then(response => {
          this.parentData = response.data[0];
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Parent Detail API Error", error);
        });
    },

    onProfileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = e => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.student_image = e.target.result;
            }
          };
          reader.readAsDataURL(files[0]);
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    removeImg() {
      this.student_image = '';
      document.getElementById('studentImage').value = '';
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
      var request = {
        params: {
          campus_id: store.state.user.campus_id,
          is_edit:true,
          acd_year_id:this.academic_year,
        }
      }

      if (fieldName == 'grade') {
        if (val == 0) {
          this.sectionArr = [{
            "id": 0,
            "text": "Choose Section"
          }];
          this.selectedSection = this.section = 0;
          this.noSectionMsg = '';
          this.isLoading = false;
          this.gradeFeeData = {'annual_fee': '', 'monthly_fee': ''};
        } else {
          this.getSection(val, request);
          this.getGradeFee(val, request);
        }
      }
      if (fieldName == "section") {
        this.section_exist = '';
      }
    },

    getSection(gradeId, request, callback = null) {
      axios.get("/class/getSection/" + gradeId, request).then((response) => {
        if (response.data[0].length > 0) {
          this.sectionArr = [{
            "id": 0,
            "text": "Choose Section"
          }].concat(response.data[0]);
          this.selectedSection = this.section = 0;
          this.noSectionMsg = '';
          this.isLoading = false;
          if (typeof callback === 'function') {
              callback();
          }
        } else {
          this.noSectionMsg = 'Please create class to show section.';
          this.sectionArr = [{
            "id": 0,
            "text": "Choose Section"
          }];
          this.selectedSection = this.section = 0;
          this.isLoading = false;
        }
      })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    // getStudentNo() {
    //   axios.get("/student/getStudentNo").then((response) => {
    //     this.c_student_no = response.data;
    //   })
    //     .catch((error) => {
    //       if (error.response.status == 401) {
    //         this.$store.commit('logout');
    //         window.location.replace('login');
    //       }
    //       this.isLoading = false;
    //     });
    // },

    getGradeName() {
      axios.get('getGradeNameByAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          "id": 0,
          "text": "All"
        }];
        this.gradeArr = $defaultSelectOption.concat(res.data);
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    confirmRegister() {
      if (this.disabled) return;
      this.submitted = true;
      if (this.$v.studentData.$invalid ||
        this.grade == 0 ||
        this.grade == '' ||
        this.section == 0 ||
        this.section == '' ||
        this.religion == 0 ||
        this.religion == '' ) {
        return;
      }
      this.register();
    },

    register() {
      this.disabled = true;
      var request = {
        parent_id: this.parentData.id,
        name: this.studentData.name,
        student_image: this.student_image,
        // c_student_no: this.c_student_no,
        entry_no: this.entry_no,
        dob: this.studentData.dob,
        gender: this.studentData.gender,
        nationality: this.studentData.nationality,
        grade: this.grade,
        religion: this.religion,
        section: this.section,
        weight: this.studentData.weight,
        blood: this.studentData.blood,
        height: this.studentData.height,
        phone1: this.studentData.phone1,
        phone2: this.studentData.phone2,
        sibling: this.studentData.sibling,
        hobby: this.studentData.hobby,
        allergic_food: this.studentData.allergic_food,
        previous_school: this.studentData.previous_school,
        special_topic: this.studentData.special_topic,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id
      }
      axios.post("/student/create", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          if (response.status == 204) {
            this.submitted = false;
            this.getSection(this.grade, {
              params: {
                campus_id: store.state.user.campus_id
              }
            });
            this.disabled = false;
            this.section_exist = "Section doesn't exist. Please choose other section.";
            return;
          }
          if (response.data.success == true) {
            this.$notification.success("Student Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "studentList"
            });
          } else {
            this.disabled = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          this.disabled = false;
          this.$notification.error("Unable to create student. Please Try Again", {
              timer: 3,
              position: "bottomCenter"
            });
          console.log("Student Create API Error", error.errors);
        });
    },

    showList() {
      this.$router.push({
        path: "/student/list"
      });
    },

    getThisAcademicYear() {
      axios.get('period/getThisPeriod')
        .then(res => {
          this.academic_year = res.data.id;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
      });
    },

    /**
      * Sets the scanned data for a student from the response.
      * 
      * @param {Object} response - The response object containing student data.
      * 
      * @returns {void}
      */
    setScannedData(response) {
      this.studentData = response.data;
      this.selectedGrade = this.normalizeScanData(response.data.grade, this.gradeArr);
      this.grade = this.selectedGrade;
      this.getSection(this.selectedGrade, 
        {
          params: {
            campus_id: store.state.user.campus_id,
            acd_year_id:this.academic_year,
          }
        }, () => { 
          this.selectedSection = this.normalizeScanData(response.data.section, this.sectionArr);
          this.section = this.selectedSection;
      });
      this.getGradeFee(this.selectedGrade, {
        params: {
          campus_id: store.state.user.campus_id,
          is_edit:true,
          acd_year_id:this.academic_year,
        }
      });
      this.selectedReligion = this.normalizeScanData(response.data.religion, this.religionArr);
      this.religion = this.selectedReligion;
      this.studentData.gender = this.normalizeScanData(response.data.gender, [{ id: 1, text: 'Male'} , { id: 2, text: 'Female'}]);
    },

    /**
      * Normalizes the scan data by finding the corresponding ID in the system data.
      *
      * @param {string} scanText - The text scanned that needs to be normalized.
      * @param {Array<{ text: string, id: number }>} systemData - The array of objects containing text and id.
      * @returns {number} - The ID corresponding to the scanned text, or 0 if not found.
      */
    normalizeScanData(scanText, systemData) {
      const selectedObject = systemData.find(
        (selectOption) => selectOption.text === scanText
      );
      return selectedObject ? selectedObject.id : 0;
    },
  },

  mounted() {
    this.isLoading = true;
    // this.getStudentNo();
    this.getParentDetail();
    this.getGradeName();
    this.getReligion();
    this.getThisAcademicYear();
  },
};
